/* istanbul ignore file */
import { FormSection, BigFormRow, MediumFormRow, FormRow } from 'framework/ui/layout';
import { TextArea, TextInput, DateInput, EnumDropdown } from 'framework/form';
import { OPPORTUNITY_PROJECT_TYPE } from 'domain/shared/presale';
import RequiredResourcesListInput from 'domain/sales/opportunity/presale/output/shared/input/RequiredResourcesListInput';
import RequiredResourcesInputTemplate from 'domain/sales/opportunity/presale/output/shared/input/RequiredResourcesInputTemplate';

const PresaleOutputForm = () => {
  return (
    <div>
      <FormSection title="Presale Artifacts">
        <BigFormRow>
          <TextArea source="descriptionText" label="Description" />
        </BigFormRow>
        <MediumFormRow>
          <EnumDropdown
            options={OPPORTUNITY_PROJECT_TYPE}
            source="projectType"
            label="Project Type"
            placeholder="Select..."
          />
        </MediumFormRow>
        <MediumFormRow>
          <TextInput source="sharepointLink" label="Sharepoint Link" />
        </MediumFormRow>
        <FormRow>
          <DateInput source="expectedProjectStart" label="Expected Start" />
        </FormRow>
      </FormSection>
      <FormSection title="Team structure">
        <BigFormRow>
          <RequiredResourcesListInput
            source="requiredResources"
            addText="Add Member"
            maxFields={30}
            inputTemplate={RequiredResourcesInputTemplate}
          />
        </BigFormRow>
      </FormSection>
    </div>
  );
};

export default PresaleOutputForm;
